import { setFeatures } from "../../template/state/modules/features";
/* global requirejs */
export const initialise = (store, context) =>
  new Promise(resolve =>
    requirejs(["asos-web-features"], ({ default: features }) => {
      let globalManifest = window.__featureManifest || {};
      const instance = features.getInstance(globalManifest, context);
      resolve(instance);
      if (window.__versionManifest) {
        const versionManifest = {
          features: { ...window.__versionManifest.features },
          mvt: { ...window.__versionManifest.mvt }
        };
        instance.addManifest(versionManifest).then(() => {
          store.dispatch(
            setFeatures({
              loadComplete: true,
              ...instance.getFeatures()
            })
          );
        });
      }
      store.dispatch(
        setFeatures({
          loadComplete: false,
          ...instance.getFeatures()
        })
      );
    })
  );



// WEBPACK FOOTER //
// ./client/sdk/features.js